import { toast } from "react-toastify";
import { messaging, getToken } from "./firebase-config";

const TOAST_ID = "notification-permission-denied";

export const requestFirebaseNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      // showPermissionDeniedToast();
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BH3-GavyyKGHyONaj4LamxgnKBj2bpn9Cg1-7BExw8SWqvJoxx49KgdteTzM8e_uQ6v3JLgaYeqo7oiYXZUzdio",
    });
    return token;
  } catch (error) {
    console.error("An error occurred while retrieving FCM token.", error);
    toast.error("Failed to retrieve FCM token.");
    throw error;
  }
};

export const showPermissionDeniedToast = () => {
  if (!toast.isActive(TOAST_ID)) {
    toast.error(
      <div>
        <strong className="text-danger d-block mb-1">
          Notification access is required
        </strong>
        <p className="mb-0">
          You denied notification permissions. Please allow them to access the
          system.
        </p>
      </div>,
      {
        toastId: TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      }
    );
  }
};
